var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text__edit"},[_c('quill-editor',{ref:"myTextEditor",staticStyle:{"height":"200px"},attrs:{"options":_vm.editorOption},model:{value:(_vm.editData.data),callback:function ($$v) {_vm.$set(_vm.editData, "data", $$v)},expression:"editData.data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }